import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';
import headerObject from '@/types/headerObj';

const endPoint = 'updateSlackUserMapping/';
const url = apiUrl + endPoint;

export interface UpdateSlackUserMappingRequest {
  OrgUUID: string;
  SlackUserId: string;
  GithubUsername?: string | null;
  GitlabUsername?: string | null;
}

export interface UpdateSlackUserMappingResponse {
  Success: boolean;
  Error?: string | null;
}

const updateSlackUserMapping = async (
  req: UpdateSlackUserMappingRequest,
  headerObj: headerObject
): Promise<UpdateSlackUserMappingResponse | null> => {
  try {
    const payload = {
      OrgUUID: req.OrgUUID,
      SlackUserId: req.SlackUserId,
      GithubUsername: req.GithubUsername || null,
      GitlabUsername: req.GitlabUsername || null,
    };

    const response = await postWithAuth(url, payload);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // Handle both JSON string and object responses
    const parsedData = typeof data === 'string' ? JSON.parse(data) : data;
    return parsedData;
  } catch (err) {
    console.error('Error updating Slack user mapping:', err);
    return null;
  }
};

export default updateSlackUserMapping;
